import { I as t } from "../../iconLoader.gen-Bv5iXotU.js";
function o(r) {
  return typeof r == "string" && r in t;
}
export {
  o as isIconName
};
